import React from 'react'
import { ChartBarHorizontalCustom } from '..'
import { getObjectAsArray, addZero } from '../../util'
import { Card, H3, Para, Stats, Values, Row, ProgressBar } from './styleCustomToolTip1'

const CustomTootTip1 = ({ data, type, insightsElementType }) => {
  const obj = data?.data?.otherDetails || data
  const otherDetails = obj?.otherDetails ? { ...obj.otherDetails } : { ...obj }
  const finalDt = otherDetails?.DriverAttributes || otherDetails?.DriverSubAttributes || otherDetails?.Attributes || otherDetails?.Attributes || otherDetails?.SubAttributes || []
  const finalData = getObjectAsArray(finalDt)
  const maxValue = Math.max(...finalData.map((d) => d.Percent))
  const isSegmentByDriversComponent = ['DriversProgressionWithoutSentiments', 'SegmentDriversAnalysis', 'SegmentDriversOnlyAnalysis', 'SegmentDriversOnlyAnalysisWithoutSentiments', 'SegmentDriversOnlyAnalysisWithoutSentiments3Level', 'SegmentDriversOnlyAnalysis3Level', 'DriversProgression3Level_v1', 'DriversProgressionWithoutSentiments3Level_v1', 'SearchDriversProgression3Level_v1'].includes(insightsElementType)

  return (
    <Card type={type} className={isSegmentByDriversComponent ? 'segmentByDriversComponent' : ''}>
      <H3>
        <Values className='percentValue' type='none'>
          <strong>{addZero(otherDetails.Percent)}%</strong>
        </Values>
        <span className='toolTipWrap'>
          <span className='toolTipHeading'>{otherDetails?.DriverName || otherDetails?.AttributeName || otherDetails?.SubAttributeName}</span>
          {isSegmentByDriversComponent && otherDetails?.TargetSegment && <span className='toolTipSubHeading'>{otherDetails?.TargetSegment}</span>}
        </span>
      </H3>
      <Para>{data.data.fullLabel}</Para>
      <Stats dataLength={finalData.length} className='statsSection'>
        <Values type='Positive'>
          <strong>{addZero(otherDetails.PositivePercent)}%</strong> Positive
        </Values>
        <Values type='Mixed'>
          <strong>{addZero(otherDetails.MixedPercent)}%</strong> Mixed
        </Values>
        <Values type='Negative'>
          <strong>{addZero(otherDetails.NegativePercent)}%</strong> Negative
        </Values>
      </Stats>

      {[...finalData].slice(0, 5).map((d, i) => {
        let array = []
        // if(d?.PositivePercent > 0 && d?.NeutralPercent > 0 && d?.MixedPercent > 0 && d?.NegativePercent > 0){
        if(d?.Percent >= 0){
          array.push({
            Positive: d.PositivePercent,
            Neutral: d.NeutralPercent,
            Mixed: d.MixedPercent,
            Negative: d.NegativePercent,
          })
        }

        if (['DriversProgressionWithoutSentiments3Level'].includes(insightsElementType)) {
          array = [{ WithoutSentiments: d.Percent }]
        } else if (['SearchDriversProgression3Level'].includes(insightsElementType)) {
          array = [{ SearchKeywords: d.Percent }]
        }

        return (
          <React.Fragment key={`id_${d.InsightsElementId}_${i}`}>
            {(d?.AttributeName || d?.SubAttributeName) && d?.Percent>=0 && <Row>
              <span>{d?.AttributeName || d?.SubAttributeName}</span>
              <span>{d.Percent}%</span>
            </Row>}
            {array?.length > 0 && <ProgressBar>
              <ChartBarHorizontalCustom
                data={array}
                showInside={false}
                bottomText={false}
                valueInPercent={true}
                maxPercentRatio={maxValue || 100}
                maxWidth='100%'
              />
            </ProgressBar>}
          </React.Fragment>
        )
      })}
    </Card>
  )
}

export default CustomTootTip1
